import { FC } from 'react';

import {
  Spacer,
  Wrapper,
} from './styled';

// @ts-ignore
import plusIcon from "assets/images/journeys/master-plan-shortcut.svg";

import { MASTER_PATH } from 'utils/routes';

interface IProps {
  isVisible: boolean;
}

const PlanShortcut: FC<IProps> = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <>
      <Spacer />

      <Wrapper to={MASTER_PATH}>
        <span>Go To Master Plan</span>
        <figure>
          <img src={plusIcon} alt="" />
        </figure>
      </Wrapper>
    </>
  );
}

export default PlanShortcut;
